import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../common/url-query/url-query.service';
import {MetaDataService} from '../../metaData/meta-data.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomersApiService {

  constructor(private http: HttpClient,
              private metaDataService: MetaDataService) { }

  readonly customersUrl: string = 'topology/customer';

  public getCustomers(params = {}): Observable<any> {
    const generatedCustomersUrl = UrlQueryService.addQueryParameters(this.customersUrl, params);

    return this.http.get(generatedCustomersUrl);
  }

  public getCustomer(id: number): Promise<any> {
    return this.http.get(`${this.customersUrl}/${id}`).toPromise();
  }

  public addCustomer(customer: any): Promise<any> {
    return this.http.post(this.customersUrl, customer).toPromise();
  }

  public editCustomer(customer: any, id: number): Promise<any> {
    return this.http.put(`${this.customersUrl}/${id}`, customer).toPromise();
  }

  public deleteCustomer(id: number): Promise<any> {
    return this.http.delete(`${this.customersUrl}/${id}`).toPromise();
  }

  public lockCustomers(ids): Promise<any> {
    const uri = `${this.customersUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.CustomersAdminState.LOCKED.value}).toPromise();
  }

  public unlockCustomers(ids): Promise<any> {
    const uri = `${this.customersUrl}/lock`;
    const url = UrlQueryService.addQueryParameters(uri, {filter: {id: {value: ids, operator: '='}}});

    return this.http.put(url, {lock: this.metaDataService.CustomersAdminState.UNLOCKED.value}).toPromise();
  }

  public deleteCustomers(ids: number[]): Promise<any> {
    const parameters = {
      filter: {
        id: {
          value: ids,
          operator: '='
        }
      }
    };
    const generatedCustomersUrl = UrlQueryService.addQueryParameters(this.customersUrl, parameters);
    return this.http.delete(generatedCustomersUrl).toPromise();
  }

  public unlockCustomer(id: number): Promise<any> {
    const url = `${this.customersUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.CustomersAdminState.UNLOCKED.value}).toPromise();
  }

  public lockCustomer(id: number): Promise<any> {
    const url = `${this.customersUrl}/${id}/lock`;
    return this.http.put(url, {lock: this.metaDataService.CustomersAdminState.LOCKED.value}).toPromise();
  }
}
